// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"228":"fe6a3d1c","317":"c8aaa66e","453":"e2191856","906":"e5c53290","908":"6cc6afa8","994":"8340327b"}[chunkId] + ".chunk.css";
};